import { Card, CardContent, CardHeader, Typography, Grid } from '@mui/material';
import { Briefcase, CheckCircle, Star } from 'lucide-react';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';

interface StatsCardsProps {
    stats: {
        activeJobs: number;
        completedJobs: number;
        averageRating: number;
    };
}

export const StatsCards = ({ stats }: StatsCardsProps) => {
    const { themeStyle } = useThemeContext();
    const iconColor = theme[themeStyle].tag_white;

    const cardItems = [
        {
            title: 'Active Jobs',
            value: stats.activeJobs,
            subtitle: 'Currently working on',
            icon: <Briefcase size={16} style={{ color: iconColor }} />,
        },
        {
            title: 'Completed Jobs',
            value: stats.completedJobs,
            subtitle: 'Successfully finished',
            icon: <CheckCircle size={16} style={{ color: iconColor }} />,
        },
        {
            title: 'Average Rating',
            value: stats.averageRating,
            subtitle: 'Out of 5.0',
            icon: <Star size={16} style={{ color: iconColor }} />,
        },
    ];

    return (
        <Grid container>
            {cardItems.map((item, index) => (
                <Grid item xs={12} md={4} px={1} key={index} pb={1}>
                    <Card sx={{ backgroundColor: theme[themeStyle].secondaryBg }}>
                        <CardHeader
                            title={
                                <Typography
                                    variant="subtitle2"
                                    fontWeight={500}
                                    sx={{ color: theme[themeStyle].tag_white }}>
                                    {item.title}
                                </Typography>
                            }
                            action={item.icon}
                            sx={{ pb: 1 }}
                        />
                        <CardContent>
                            <Typography variant="h5" fontWeight="bold" sx={{ color: theme[themeStyle].tag_white }}>
                                {item.value}
                            </Typography>
                            <Typography variant="caption" sx={{ color: theme[themeStyle].tag_white }}>
                                {item.subtitle}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
};
